import isEqual from "lodash/isEqual";
import create from "zustand";
interface ContextEntry {
  url?: string;
  customerID?: string;
  craftRecordID?: string;
  taskID?: string;
  invoiceID?: string;
  estimateID?: string;
  timestamp: string; // ISO string timestamp
  pageType?: string; // e.g., 'customer', 'job', 'invoice', etc.
}

interface UserContextState {
  contextHistory: ContextEntry[];
  addContext: (entry: Omit<ContextEntry, "timestamp">) => void;
}

// Maximum number of context entries to keep
const MAX_CONTEXT_HISTORY = 10;

export const useUserContextStore = create<UserContextState>((set, get) => ({
  contextHistory: [],

  addContext: (entry) =>
    set((state) => {
      // Add timestamp if not provided
      const newEntry: ContextEntry = {
        ...entry,
        timestamp: new Date().toISOString(),
      };

      // Check if the new entry is the same as the last entry (excluding timestamp)
      const lastEntry = state.contextHistory[0];
      const lastEntryWithoutTimestamp = {
        ...lastEntry,
        timestamp: undefined,
      };
      const newEntryWithoutTimestamp = {
        ...newEntry,
        timestamp: undefined,
      };
      if (isEqual(lastEntryWithoutTimestamp, newEntryWithoutTimestamp)) {
        return { contextHistory: state.contextHistory };
      }

      // Create new history with the new entry at the beginning
      const newHistory = [newEntry, ...state.contextHistory];

      // Limit to MAX_CONTEXT_HISTORY entries
      if (newHistory.length > MAX_CONTEXT_HISTORY) {
        newHistory.length = MAX_CONTEXT_HISTORY;
      }

      return { contextHistory: newHistory };
    }),
}));
